export default {
  minuteStr(minute) {
    const hours = Math.floor(minute / 60);
    const min = minute % 60;
    let str = hours ? `${hours}時間` : "";
    str += `${min}分`;
    return str;
  }
}